import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';

// SIMPLE SELECT BOX (HTML SELECT)
export function SelectBox({ name, value, onChange, data }) {
  return (
    <select
      name={name}
      value={value}
      onChange={onChange}
      style={{
        backgroundColor: "transparent",
        padding: "10px 20px",
        marginTop: 9,
        minWidth: 140,
      }}
    >
      <option value={0}>select</option>
      {data.map(({ id, name }) => (
        <option key={id} value={id}>
          {name}
        </option>
      ))}
    </select>
  );
}


// MUI DROPDOWN
export function Dropdown({
  addClassName,
  label,
  name,
  customName = 'name',
  customId = 'id',
  error,
  value,
  disabled,
  required,
  style,
  fullWidth,
  helperText,
  onChange,
  data = [],
  className,
  hideSelect,
  size,
  labelBackGroundClassName,
  variant,
  multiple,
}) {

  const selectedValues = multiple
    ? (Array.isArray(value) ? value : (value ? String(value).split(',').filter(Boolean) : []))
    : value;
  const labelById = {};
  data.forEach((item) => {
    labelById[item[customId]] = item[customName];
  });

  const onChangeYear = (e, index) => {
    if (multiple || e.target.value !== 0 || (!required && !hideSelect)) {
      onChange(e, index);
    }
  };

  return (
    <div className={className}>
      <FormControl
        required={required}
        error={!!error}
        variant={variant || 'outlined'}
        fullWidth={fullWidth}
        sx={{
          maxWidth: "320px",
          width: '100%',
          minWidth: "220px",
          ...style
        }}
      >
        <InputLabel className={labelBackGroundClassName}>
          {label}
        </InputLabel>

        <Select
          name={name}
          multiple={!!multiple}
          value={selectedValues}
          size={size || 'medium'}
          disabled={disabled}
          onChange={onChangeYear}
          className={addClassName}
          label={label} // IMPORTANT for outlined variant
          renderValue={multiple
            ? (selected) => (selected || []).map((id) => labelById[id] || id).join(', ')
            : undefined}
        >
          {!hideSelect && !required && (
            <MenuItem value={0}>
              <em>Select</em>
            </MenuItem>
          )}

          {data.length === 0 && hideSelect && (
            <MenuItem value={0}>
              <em>No Data</em>
            </MenuItem>
          )}

          {data.length !== 0 &&
            data.map((item) => (
              <MenuItem
                key={item[customId]}
                value={item[customId]}
              >
                {multiple && (
                  <Checkbox checked={selectedValues.indexOf(item[customId]) > -1} size="small" />
                )}
                {multiple ? <ListItemText primary={item[customName]} /> : item[customName]}
              </MenuItem>
            ))}
        </Select>

        {error && <FormHelperText>{error}</FormHelperText>}

        {value === '' && !error && (
          <FormHelperText>{helperText}</FormHelperText>
        )}
      </FormControl>
    </div>
  );
}